module.exports = __webpack_public_path__ + "img/default-user.17ce7ff4.png";